import * as React from 'react';

function SvgUser(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 17 16" {...props}>
			<path
				fill="#1ED560"
				fillRule="evenodd"
				d="M1.685 16h14.437c.431 0 .782-.35.782-.781v-3.094c0-2.243-1.246-4.27-3.252-5.29l-.196-.1.073-.207c.186-.53.28-1.076.28-1.622C13.81 2.2 11.61 0 8.904 0S3.998 2.2 3.998 4.906c0 .545.094 1.091.28 1.622l.074.208-.197.1C2.15 7.856.904 9.882.904 12.125v3.094c0 .43.35.781.78.781zM8.904 1.56c1.845 0 3.346 1.5 3.346 3.346 0 1.845-1.501 3.346-3.346 3.346-1.845 0-3.346-1.501-3.346-3.346 0-1.846 1.5-3.347 3.346-3.347zm-6.44 10.565c0-1.692.995-3.249 2.536-3.966l.167-.078.125.136C6.222 9.23 7.538 9.81 8.904 9.81s2.682-.58 3.612-1.594l.124-.136.167.078c1.542.717 2.537 2.274 2.537 3.966v2.316H2.464v-2.316z"
			/>
		</svg>
	);
}

export default SvgUser;
